import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { HStack, Spacer } from '@/components/Layout';
import useDocumentTitle from '@/hooks/useDocumentTitle';
import { defaultNS, useTranslation } from '@/lib/i18n';
import { EquipmentForm } from './-components/EquipmentForm';
import { InnerNavigation } from './-components/InnerNavigation';
import { ProgressCard } from './-components/ProgressCard';
import { useAddEquipmentFormStore } from './-store/add-equipment-form-store';
export const Route = createFileRoute('/_staff/equipment/add/')({
  component: EquipmentAdd
});
function EquipmentAdd() {
  const {
    t
  } = useTranslation(defaultNS, {
    keyPrefix: 'pages.equipment.add'
  });
  useDocumentTitle(t('pageTitle'));
  const reset = useAddEquipmentFormStore(state => state.reset);
  useEffect(() => {
    // コンポーネントマウント時にフォームデータをリセット
    // 注: 初回マウント時のみリセット。エラー後の再レンダリング時はリセットしない
    return () => {
      // アンマウント時にリセット（他の画面に遷移する時）
      reset();
    };
  }, [reset]);
  return <HStack className="w-full p-6">
      <InnerNavigation />
      <Spacer variant="m" />
      <EquipmentForm className="grow min-w-[340px]" />
      <Spacer variant="m" />
      <ProgressCard />
    </HStack>;
}